












































































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  defaultUpdateCollectionMemoInfoItem,
  UpdateCollectionMemoCollectionInfoItem
} from '@/components/organisms/UpdateCollectionMemoCollectionInfo/index.type'

@Component({
  components: {}
})
export default class UpdateCollectionMemoCollectionInfo extends ComponentVue {
  @Prop({
    type: Object,
    default: defaultUpdateCollectionMemoInfoItem
  })
  item!: UpdateCollectionMemoCollectionInfoItem
}
